import Colors from '@constants/Colors';
import { Box, LinearProgress, Stack, Typography } from '@mui/material';
import { getFileIcon, getFileIconColor } from '@utils/fileHelpers';
import React from 'react';

interface FileUploadProgressProps {
    fileName: string;
    progress?: number;
    mimetype?: string;
}

const FileUploadProgress: React.FC<FileUploadProgressProps> = ({ fileName, progress = 0, mimetype }) => {
    const fileIconClass = getFileIcon(mimetype, fileName);
    const fileIconColor = getFileIconColor(mimetype, fileName);

    return (
        <Box
            sx={{
                width: '100%',
                height: '187px',
                border: `1px solid ${Colors.NEUTRAL_GRAY}`,
                borderRadius: '16px',
                overflow: 'hidden',
                backgroundColor: 'white',
                position: 'relative',
            }}>
            {/* Preview Area with Overlay */}
            <Box
                sx={{
                    height: '123px',
                    borderBottom: `1px solid ${Colors.NEUTRAL_GRAY}`,
                    backgroundColor: Colors.NEUTRAL_LIGHT_GRAY,
                    position: 'relative',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    overflow: 'hidden',
                }}>
                {/* File Icon */}
                <Box
                    component="i"
                    className={fileIconClass}
                    sx={{
                        fontSize: '64px',
                        color: fileIconColor,
                    }}
                />

                {/* Upload Overlay */}
                <Box
                    sx={{
                        position: 'absolute',
                        top: 0,
                        left: 0,
                        right: 0,
                        bottom: 0,
                        backgroundColor: 'rgba(55, 16, 69, 0.33)',
                        backdropFilter: 'blur(1px)',
                        display: 'flex',
                        flexDirection: 'column',
                        alignItems: 'center',
                        justifyContent: 'center',
                        gap: '6px',
                    }}>
                    {/* Uploading Text */}
                    <Typography
                        sx={{
                            fontFamily: 'Plus Jakarta Sans',
                            fontSize: '13px',
                            fontWeight: 500,
                            lineHeight: '16px',
                            color: 'white',
                            textAlign: 'center',
                            width: '119px',
                        }}>
                        Téléchargement...
                    </Typography>

                    {/* Progress Bar */}
                    <Box
                        sx={{
                            width: '119px',
                            height: '5px',
                            borderRadius: '7px',
                            overflow: 'hidden',
                        }}>
                        <LinearProgress
                            variant="determinate"
                            value={progress}
                            sx={{
                                height: '100%',
                                backgroundColor: 'transparent',
                                '& .MuiLinearProgress-bar': {
                                    backgroundColor: '#5447de',
                                    borderRadius: '26px',
                                },
                            }}
                        />
                    </Box>
                </Box>
            </Box>

            {/* File Info */}
            <Stack
                spacing={0.4}
                sx={{
                    padding: '9px',
                }}>
                <Typography
                    sx={{
                        fontFamily: 'Plus Jakarta Sans',
                        fontSize: '13px',
                        fontWeight: 700,
                        lineHeight: '16px',
                        color: '#000000',
                        overflow: 'hidden',
                        textOverflow: 'ellipsis',
                        whiteSpace: 'nowrap',
                    }}>
                    {fileName}
                </Typography>
                <Typography
                    sx={{
                        fontFamily: 'Plus Jakarta Sans',
                        fontSize: '13px',
                        fontWeight: 500,
                        lineHeight: '16px',
                        color: Colors.NEUTRAL_GRAY,
                    }}>
                    Téléchargement...
                </Typography>
            </Stack>
        </Box>
    );
};

export default FileUploadProgress;
